import React, { Component } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// eslint-disable-next-line react/prefer-stateless-function
export default class SliderItems extends Component {
  render() {
    const settings = {
      dots: true,
      autoplay: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 2,
      arrow: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 2,
            autoplay: true,
          },
        },
      ],
    };
    return (
      <div className="bg-gray">
        <div className="container mx-auto w-4/6 py-6 my-12 lg:text-center">
          <Slider {...settings} className="lg:px-20">
            <div className="text-center">
              <StaticImage
                src="../../images/ojk-award.png"
                alt="media-1"
                objectFit="contain"
                className="w-44 lg:w-64"
                placeholder="none"
              />
            </div>
            <div className="text-center">
              <StaticImage
                src="../../images/g20-award.png"
                alt="media-2"
                objectFit="contain"
                className="w-44 lg:w-64"
                placeholder="none"
              />
            </div>
            <div className="text-center">
              <StaticImage
                src="../../images/eastjava-award.png"
                alt="media-3"
                objectFit="contain"
                className="w-44 lg:w-64"
                placeholder="none"
              />
            </div>
            <div className="text-center">
              <StaticImage
                src="../../images/ojk-award.png"
                alt="media-4"
                objectFit="contain"
                className="w-44 lg:w-64"
                placeholder="none"
              />
            </div>
            <div className="text-center">
              <StaticImage
                src="../../images/g20-award.png"
                alt="media-5"
                objectFit="contain"
                className="w-44 lg:w-64"
                placeholder="none"
              />
            </div>
            <div className="text-center">
              <StaticImage
                src="../../images/eastjava-award.png"
                alt="media-6"
                objectFit="contain"
                className="w-44 lg:w-64"
                placeholder="none"
              />
            </div>
          </Slider>
        </div>
      </div>
    );
  }
}
